{
  "more": "المزيد من العناصر"
}
